import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VmEsposizionePratica } from '../../../../core/api/models/vmEsposizionePratica.model';

import {
  ApiService,
  ROUTE_ANIMATIONS_ELEMENTS
} from '../../../../core/core.module';

@Component({
  selector: 'mydyn-rate',
  templateUrl: './rate.component.html',
  styleUrls: ['./rate.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RateComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  appLoading = false;
  today: Date = new Date();
  rate: VmEsposizionePratica[] = [];
  displayedColumns: string[] = [
    'numero',
    'dataScadenza',
    'importo',
    'capitale',
    'interessi',
    'stato'
  ];

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.appLoading = true;
    this.route.parent.params.subscribe((params) => {
      this.apiService
        .findVmEsposizionePraticaByIdPratica(+params['id'])
        .subscribe(response => {
          if (response !== null) {
            this.rate = [].concat(response);
          }
          this.appLoading = false;
          this.cd.detectChanges();
        });
    });
  }
}
